import type RetsOpenHouse from '@bb/domain/dist/types/RetsOpenHouse';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const findLatestRetsOpenHouseByRetsUniqueId = async ({
  retsUniqueId,
  listingRef,
}: {
  listingRef?: string;
  retsUniqueId: string;
}) => {
  const searchParams = new URLSearchParams({
    ...(listingRef && { listingRef }),
    retsUniqueId,
  });

  const config: AxiosRequestConfig = {
    method: 'GET',
    url: `/rets/openhouse/uid?${searchParams.toString()}`,
  };

  const { data } = await axios.request<RetsOpenHouse>(config);

  return data;
};

export default findLatestRetsOpenHouseByRetsUniqueId;
